/*======================================================================================================================
  * Bluebell: src/app/state/text-columns/text-columns.actions.ts
  * Last Edited: 29/07/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { createAction, props } from '@ngrx/store';
import { TextColumn } from '@state/text-columns/text-columns.interfaces';


const name = (action: string) => `[Text Columns] ${action}`;

export const createTextColumn = createAction(name('Create'), props<{ name: string }>());
export const createTextColumnSuccess = createAction(name('Create Success'), props<{ column: TextColumn }>());
export const createTextColumnFailure = createAction(name('Create Failure'));

export const listTextColumns = createAction(name('List'));
export const listTextColumnsSuccess = createAction(name('List Success'), props<{ columns: TextColumn[] }>());
export const listTextColumnsFailure = createAction(name('List Failure'));

export const updateTextColumn = createAction(name('Update'), props<{ uuid: string, name: string }>());
export const updateTextColumnSuccess = createAction(name('Update Success'), props<{ column: TextColumn }>());
export const updateTextColumnFailure = createAction(name('Update Failure'));

export const deleteTextColumn = createAction(name('Delete'), props<{ uuid: string }>());
export const deleteTextColumnSuccess = createAction(name('Delete Success'), props<{ uuid: string }>());
export const deleteTextColumnFailure = createAction(name('Delete Failure'));
